(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DecapCmsBackendGitea", [], factory);
	else if(typeof exports === 'object')
		exports["DecapCmsBackendGitea"] = factory();
	else
		root["DecapCmsBackendGitea"] = factory();
})(window, () => {
return 